export default {"src":"/_next/static/media/continuous-monitoring.fc0d8ee7.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};